import {BaseEntity} from './base-entity';

export type SharedDocumentStatusType = 'NEW' | 'VIEWED' | 'LINKED';
export const DOC_STATUS_IS_NEW = 'New';
export const DOC_STATUS_IS_UPDATED = 'Updated';
export class SharedDocument extends BaseEntity {
    id: number;
    name: string;
    status: SharedDocumentStatusType;
    description: string;
    date: string;
    lastSharedTimeStamp: number;
    lastViewedTimeStamp: number;

    get docStatus() : string {
        if(!this.lastViewedTimeStamp){
            return DOC_STATUS_IS_NEW;
        }
        if(this.lastViewedTimeStamp < this.lastSharedTimeStamp){
            return DOC_STATUS_IS_UPDATED;
        }
        return '';
    }

}
